import { readable, writable, derived } from "svelte/store";

import { getTextColor } from "./utils";
import { currentMonthIndex } from "./constants";

export const selectedMode = writable("months");
export const selectedBaseline = writable("all");
export const selectedMonthIndex = writable(currentMonthIndex);

export const selectedMonthColor = writable();
export const lastYearColor = writable();

export const selectedMonthTextColor = derived(selectedMonthColor, (selectedMonthColor) =>
	getTextColor(selectedMonthColor)
);
export const lastYearTextColor = derived(lastYearColor, (lastYearColor) =>
	getTextColor(lastYearColor)
);
